import React from 'react';

const Send = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className="rcx-svg--directional"
    fill="currentColor"
    {...props}
  >
    <path d="M27.4382 6.03045C27.6835 6.32799 27.7359 6.74008 27.5728 7.08955L18.2395 27.0895C18.0617 27.4707 17.6644 27.6998 17.2454 27.6628C16.8265 27.6258 16.4755 27.3307 16.3671 26.9243L13.8165 17.3596L4.88612 12.8944C4.51182 12.7073 4.29364 12.3069 4.3393 11.8909C4.38497 11.4749 4.68482 11.1313 5.0908 11.0299L26.4241 5.69652C26.7983 5.60299 27.1928 5.73292 27.4382 6.03045ZM15.8069 17.0615L17.5906 23.7506L24.8728 8.1459L8.19841 12.3145L14.5611 15.4958L16.7333 13.8667C17.1752 13.5353 17.802 13.6248 18.1333 14.0667C18.4647 14.5085 18.3752 15.1353 17.9333 15.4667L15.8069 17.0615Z" />
  </svg>
);

export default Send;
